import React from "react";
import { WrapperPage } from "../../components/shared/WrapperPage";
import ChannelTeam from "../../components/channel-team";
import { useAppContext } from "../../context";
import { isPME_TEAM } from "../../helper";

export default function ChannelTeamPage() {
    const { currentUser } = useAppContext();
    const isPME = isPME_TEAM(currentUser);

    return (
        <WrapperPage>
            {isPME ? (
                <ChannelTeam />
            ) : (
                <p>You don't have privilege to access this route</p>
            )}
        </WrapperPage>
    );
}
